/**
 * Easy selector helper function
 */
const Select = (el, all = false) => {
  el = el.trim();
  if (all) {
    return [...document.querySelectorAll(el)];
  } else {
    return document.querySelector(el);
  }
};
/**
 * Easy on scroll event listener
 */
const OnScroll = (el, listener) => {
  el.addEventListener('scroll', listener);
};
/**
 * Easy set attribute helper function
 */
const SetAttributes = (el, attrs) => {
  for (const key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
};
/**
 * Easy event listener function
 */
const On = (type, el, listener, all = false) => {
  const selectEl = Select(el, all);
  if (selectEl) {
    if (all) {
      selectEl.forEach((e) => e.addEventListener(type, listener));
    } else {
      selectEl.addEventListener(type, listener);
    }
  }
};

export { Select, SetAttributes, On, OnScroll };
